import React from 'react';
import { InfoCeldasProvider, useInfoCeldas } from './InfoCeldasContext';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router-dom';
import '../../styles/InfoCeldas.css';

import GeneralData from './GeneralData';
import SelecTCelda from '../../components/SelectCelda/SelectCelda';
import UpdateData from './UpdateData';
import TabIndi from './TabIndi';
import Cards from './Cards';

function InfoCeldas() {
    const { meses, dias, startCorrida, mttr, mtbf, porUti, porEfi } = useInfoCeldas();
    const cookie = new Cookies();

    return (
        <div className="infoCeldasView">
            <div className="infoCeldasViewHead">
                <div className="infoCeldasViewHeadField">
                    <h1 className="infoCeldasViewHeadTitulo">Información Celdas</h1>
                    <p>{cookie.get('nombreL')}</p>
                    <h4>
                        {dias[new Date().getDay()]}
                        {', '}
                        {new Date().toISOString().slice(8, 10)} {meses[new Date().getMonth()]}{' '}
                        {new Date().toISOString().slice(0, 4)}
                    </h4>
                </div>
                <SelecTCelda flag={0} />
            </div>
            <div className="InfoCeldasViewBody">
                <div className="infoCeldas-body-Field">
                    <div className="InfoCeldasViewBodyGeneral">
                        <GeneralData />
                    </div>
                    <div className="InfoCeldasViewBodyUpdate">
                        <UpdateData />
                    </div>
                </div>
                <div
                    style={{
                        display: startCorrida ? 'flex' : 'none',
                        justifyContent: 'center',
                    }}
                >
                    <TabIndi />
                </div>

                <div
                    className="homeView-body-graphs"
                    style={{
                        display: startCorrida ? 'flex' : 'none',
                    }}
                >
                    <Cards value={porUti} tipo={'%'} titulo={'% OEE'} showcontent={1} />
                    <Cards value={porEfi} tipo={'%'} titulo={'% TEEP'} showcontent={1} />
                    <Cards value={mtbf} tipo={'hh:mm'} titulo={'MTBF'} showcontent={0} />
                    <Cards value={mttr} tipo={'hh:mm'} titulo={'MTTR'} showcontent={0} />
                </div>
            </div>
        </div>
    );
}

let CeldasProviderComp = () => {
    let history = useHistory();
    if (!process.env.REACT_APP_ALLOW_MONITORING_VIEW) {
        history.replace('/');
        return <></>;
    }
    return (
        <InfoCeldasProvider>
            <InfoCeldas></InfoCeldas>
        </InfoCeldasProvider>
    );
};

export default CeldasProviderComp;
